import { createReducer, PayloadAction } from "@reduxjs/toolkit";

import { ActionTypes, ConfiguracoesEducador } from "./types";

export const reducers = createReducer({} as ConfiguracoesEducador, {
  [ActionTypes.SET]: (state, action: PayloadAction<ConfiguracoesEducador>) => {
    return {
      ...state,
      ...action.payload,
    };
  },
});
